import { render } from "./DataSources.vue?vue&type=template&id=6c062b4e"
import script from "./DataSources.vue?vue&type=script&lang=js"
export * from "./DataSources.vue?vue&type=script&lang=js"

import "./DataSources.vue?vue&type=style&index=0&id=6c062b4e&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__